// extracted by mini-css-extract-plugin
export default {"WorldCupBar_title":"worldcupbar_WorldCupBar_title__wGbru","WorldCupBar_round":"worldcupbar_WorldCupBar_round__SE8Or"};